module.exports = __webpack_public_path__ + "static/topView-1e599ce7dcb1fc5db1f150be7d8cc68f.png";